import { isEmpty, isNil, isString } from 'lodash';
import { ACCOUNTS_V2_URL, NEW_TOOLS_LINKS, SENTINEL_1_TRANSFER_PERMISSIONS, SENTINEL_2_TRANSFER_PERMISSIONS, ACATS_PERMISSIONS, FRACTIONAL_TRADING_PERMISSIONS, LEGIT_PERMISSIONS, SENTINEL_2_PERMISSIONS, SKETCH_PERMISSIONS, BRAGGART_PERMISSIONS, TRADE_PROCESSING_PERMISSIONS, ACCOUNTS_V2_TRANSFERS_URL } from './constants';

export var hasAllPermissions = function hasAllPermissions() {
  var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var expectedPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var uniquePermissions = new Set();
  var hasAll = true;
  // Get the unique permission set, in case the set has the same permission twice
  if (permissions) {
    permissions.forEach(function (perm) {
      if (perm && perm.permitted) {
        var permission = perm.request.permission;

        uniquePermissions.add(permission);
      }
    });
  }
  expectedPermissions.forEach(function (expected) {
    if (!uniquePermissions.has(expected)) {
      hasAll = false;
    }
  });
  return hasAll;
};

export var buildLegacyMenu = function buildLegacyMenu(items, legacyUrl) {
  var allTransformedLinks = items.map(function (item) {
    var completeUrl = item && item.urlText;
    if (!isNil(item) && !isNil(item.webLinkId) && !isNil(completeUrl) && !completeUrl.includes('http')) {
      completeUrl = legacyUrl + '&LinkID=' + item.webLinkId;
    }
    return {
      label: item.headerText,
      href: completeUrl,
      parentHeader: item.parentHeader,
      linkId: item.webLinkId
    };
  });
  return allTransformedLinks;
};

export var setAllowedPermissions = function setAllowedPermissions(permissions) {
  var hasAccess = {
    hasAccessToTransferSentinel1: hasAllPermissions(permissions, SENTINEL_1_TRANSFER_PERMISSIONS),
    hasAccessToTransferSentinel2: hasAllPermissions(permissions, SENTINEL_2_TRANSFER_PERMISSIONS),
    hasAccessToAcats: hasAllPermissions(permissions, ACATS_PERMISSIONS),
    hasAccessToFractionalTrading: hasAllPermissions(permissions, FRACTIONAL_TRADING_PERMISSIONS),
    hasAccessToLegit: hasAllPermissions(permissions, LEGIT_PERMISSIONS),
    hasAccessToSentinel2: hasAllPermissions(permissions, SENTINEL_2_PERMISSIONS),
    hasAccessToSketch: hasAllPermissions(permissions, SKETCH_PERMISSIONS),
    hasAccessToBraggart: hasAllPermissions(permissions, BRAGGART_PERMISSIONS),
    hasAccessToTradeProcessing: hasAllPermissions(permissions, TRADE_PROCESSING_PERMISSIONS)
  };
  return hasAccess;
};

export var buildToolsItems = function buildToolsItems(allowedPermissions, accountNumber) {
  var items = NEW_TOOLS_LINKS.map(function (item) {
    return [item.key, Object.assign({}, item)];
  });
  var allLinks = new Map(items);
  var enforcePermissions = function enforcePermissions(hasPermission, permissionName) {
    if (!hasPermission) {
      allLinks.delete(permissionName);
    }
  };

  // remove the ach transfers link if the user doesn't have permissions for either sentinel 1 or 2 transfers
  if (!allowedPermissions.hasAccessToTransferSentinel1 && !allowedPermissions.hasAccessToTransferSentinel2) {
    allLinks.delete('AchTransfers');
  }

  allLinks.forEach(function (item) {
    var currentLink = allLinks.get(item.key);
    // If the account number is present, update the ach relationships and transfers linsk to use it
    if (!isNil(accountNumber) && !isEmpty(accountNumber)) {
      if (currentLink.parentHeader === 'Apex Accounts' || currentLink.label === 'Trade Processing') {
        if (currentLink.label === 'Trade Processing' || currentLink.label === 'Cash Transfers') {
          currentLink.href += currentLink.pageHref + '/' + accountNumber;
        } else {
          currentLink.href += '/' + accountNumber + currentLink.pageHref;
        }
      }
    } else {
      currentLink.href += currentLink.pageHref;
    }
    allLinks.set(item.key, currentLink);
  });

  // update the ach transfers label and href if the user has permissions for sentinel 2 transfers
  if (allowedPermissions.hasAccessToTransferSentinel2) {
    var transfersLink = allLinks.get('AchTransfers') || {};
    transfersLink.label = 'Cash Transfers';
    transfersLink.href = !isNil(accountNumber) && !isEmpty(accountNumber) && isString(accountNumber) ? ACCOUNTS_V2_TRANSFERS_URL(accountNumber) : ACCOUNTS_V2_URL;
    allLinks.set('AchTransfers', transfersLink);
  }

  // remove links if the user doesn't have the right permissions
  enforcePermissions(allowedPermissions.hasAccessToAcats, 'Acats');
  enforcePermissions(allowedPermissions.hasAccessToFractionalTrading, 'FractionalTrading');
  enforcePermissions(allowedPermissions.hasAccessToLegit, 'Legit');
  enforcePermissions(allowedPermissions.hasAccessToSentinel2, 'Sentinel2');
  enforcePermissions(allowedPermissions.hasAccessToSketch, 'Sketch');
  enforcePermissions(allowedPermissions.hasAccessToBraggart, 'BraggartSupport');
  enforcePermissions(allowedPermissions.hasAccessToTradeProcessing, 'TradeProcessing');

  var links = Array.from(allLinks.values());
  return links;
};